import { render, staticRenderFns } from "./SwipePhoto.vue?vue&type=template&id=10a2c182&"
import script from "./SwipePhoto.vue?vue&type=script&lang=js&"
export * from "./SwipePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports